<app-shared-freshness-indicator-component
  [currentStore]="currentStore"
  [dataType]="dataType"
  [timeStamps]="dataTimeStamps$ | ngrxPush">
</app-shared-freshness-indicator-component>
